import { NgModule } from '@angular/core';
import { CountdownComponent } from './countdown.component';
import { CommonModule } from '@angular/common';


@NgModule({
    declarations: [
    ],
    imports: [
        CountdownComponent,
        CommonModule
    ],
    exports: [
        CountdownComponent
    ],
})
export class CountdownModule
{
}
